/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Downloaden",
      "Cookies accepteren",
      "Cookie-instellingen",
      "Cookiebeleid",
      "Annuleren",
      "Onjuist telefoonnummer",
      "© {{current_year}} Bumble | Alle rechten voorbehouden",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Over",
      "Ambassadeurs",
      "Blog",
      "We gebruiken cookies. Als je je instellingen niet aanpast, gaan we ervan uit dat je daarmee instemt.",
      "Download de app",
      "Downloaden voor Android",
      "Downloaden voor iOS",
      "Helaas is de pagina die je zoekt niet te vinden",
      "Inloggen",
      "Aanmelden",
      "Doe mee!",
      "Oeps, er ging iets fout"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "dagen"
            ],
            "singular": [
                  "dag"
            ]
      },
      "hour": {
            "plural": [
                  "uur"
            ],
            "singular": [
                  "uur"
            ]
      },
      "minute": {
            "plural": [
                  "minuten"
            ],
            "singular": [
                  "minuut"
            ]
      },
      "month": {
            "plural": [
                  "maanden"
            ],
            "singular": [
                  "maand"
            ]
      },
      "second": {
            "plural": [
                  "seconden"
            ],
            "singular": [
                  "seconde"
            ]
      },
      "year": {
            "plural": [
                  "jaar"
            ],
            "singular": [
                  "jaar"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
